const indexData = [
  { title: '悬疑烧脑剧场', count: '128部', icon: 'ri-search-eye-line', color: 'bg-primary-100 text-primary-700' },
  { title: '古装传奇大剧', count: '96部', icon: 'ri-ancient-gate-line', color: 'bg-accent-100 text-accent-700' },
  { title: '都市情感热播', count: '215部', icon: 'ri-heart-line', color: 'bg-secondary-100 text-secondary-700' },
  { title: '仙侠玄幻巨制', count: '83部', icon: 'ri-moon-line', color: 'bg-primary-100 text-primary-700' },
  { title: '刑侦犯罪实录', count: '67部', icon: 'ri-police-car-line', color: 'bg-accent-100 text-accent-700' },
  { title: '喜剧轻松一刻', count: '142部', icon: 'ri-emotion-laugh-line', color: 'bg-secondary-100 text-secondary-700' },
  { title: '科幻未来世界', count: '54部', icon: 'ri-rocket-line', color: 'bg-primary-100 text-primary-700' },
  { title: '青春校园回忆', count: '89部', icon: 'ri-book-open-line', color: 'bg-accent-100 text-accent-700' },
  { title: '经典老剧重温', count: '310部', icon: 'ri-film-line', color: 'bg-secondary-100 text-secondary-700' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
            <i className="ri-grid-line"></i>
            分类浏览
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">精选专题</h2>
          <p className="mt-2 text-foreground-500 text-sm">九大分类专题，快速找到你想看的类型</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {indexData.map((item) => (
            <a
              key={item.title}
              href="#ranking"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex items-center gap-3 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200 hover:border-primary-200 hover:shadow-sm transition-all duration-200 cursor-pointer"
            >
              <div className={`flex-shrink-0 w-10 h-10 md:w-11 md:h-11 rounded-xl flex items-center justify-center ${item.color}`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-400 mt-0.5">{item.count}</p>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors flex-shrink-0"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}